import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";
import api, { resolveAsset } from "../lib/api";

const TestimonialsPage = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/testimonials", { params: { active_only: true } }).then((r) => setItems(r.data));
  }, []);

  return (
    <main className="pt-32 pb-24 min-h-screen" data-testid="testimonials-page">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="text-brand-blue font-heading font-bold tracking-wider uppercase text-xs">Testimonials</span>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold mt-2">From the families we serve</h1>
          <p className="mt-3 text-[color:var(--text-secondary)]">
            The kindest words come from our preschool community.
          </p>
        </div>

        {items.length === 0 ? (
          <div className="text-center text-[color:var(--text-secondary)]">No testimonials yet.</div>
        ) : (
          <div className="grid md:grid-cols-2 gap-6">
            {items.map((t, i) => (
              <div key={t.id} className="card-soft bg-white p-7" data-testid={`testimonials-page-item-${i}`}>
                <div className="flex gap-1 mb-3">
                  {Array.from({ length: t.rating || 5 }).map((_, k) => (
                    <Star key={k} size={16} className="fill-brand-yellow text-brand-yellow" />
                  ))}
                </div>
                <p className="leading-relaxed">"{t.message}"</p>
                <div className="mt-5 flex items-center gap-3">
                  <div className="w-11 h-11 rounded-full bg-light-blue flex items-center justify-center font-heading font-bold text-brand-blue">
                    {t.photo_url ? <img src={resolveAsset(t.photo_url)} alt="" className="w-full h-full rounded-full object-cover" /> : t.name.charAt(0)}
                  </div>
                  <div>
                    <div className="font-heading font-bold text-sm">{t.name}</div>
                    <div className="text-xs text-[color:var(--text-secondary)]">{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </main>
  );
};

export default TestimonialsPage;
